// extracted by mini-css-extract-plugin
export default {"labelContainer":"FieldStartDate_labelContainer__yNiCx"};